import { useRef, useState } from "react";

import { Alert, Button, Label, TextInput } from "@/ui";
import { Link } from "react-router-dom";

import { useAuth } from "@/contexts/auth-context";

export default function ForgotPassword() {
  const emailRef = useRef<HTMLInputElement>(null);
  const { resetPassword } = useAuth();
  const [error, setError] = useState<string | null>(null);
  const [message, setMessage] = useState<string | null>(null);
  const [loading, setLoading] = useState(false);

  async function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();

    try {
      setError("");
      setLoading(true);
      await resetPassword(emailRef.current!.value);
      setMessage("Check your inbox for further instructions");
    } catch (err) {
      setError("Failed to reset password");
    }

    setLoading(false);
  }

  return (
    <>
      <section className="w-full min-h-full">
        <div className="flex flex-col items-center justify-center px-6 py-8 mx-auto">
          <a
            href="/"
            className="flex items-center mb-6 text-2xl text-ink-primary font-extrabold tracking-tight"
          >
            Lift Notes
          </a>
          <div className="w-full bg-surface-card rounded-card border border-line-subtle md:mt-0 sm:max-w-md xl:p-0">
            <div className="p-6 space-y-4 md:space-y-6 sm:p-8">
              <h1 className="text-xl font-bold leading-tight tracking-tight text-ink-primary md:text-2xl">
                Reset Password
              </h1>
              <form onSubmit={handleSubmit} className="flex flex-col gap-4">
                {error && (
                  <Alert color="failure">
                    <span>{error}</span>
                  </Alert>
                )}
                {message && (
                  <Alert color="info">
                    <span>{message}</span>
                  </Alert>
                )}
                <div>
                  <div className="mb-2 block">
                    <Label htmlFor="email1">Email</Label>
                  </div>
                  <TextInput
                    id="email1"
                    type="email"
                    ref={emailRef}
                    placeholder="name@swole.net"
                    required={true}
                    autoComplete="on"
                  />
                </div>
                <div className="py-2.5">
                  <Button
                    disabled={loading}
                    variant="gradient"
                    type="submit" fullWidth
                  >
                    Reset Password
                  </Button>{" "}
                </div>
                <div className="w-100 text-center mt-3 text-sm font-light text-ink-muted">
                  <Link
                    to="/login"
                    className="font-medium text-brand-ink hover:underline"
                  >
                    Sign in
                  </Link>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
